import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M6 17.468V6.532c0-1.554 1.696-2.514 3.029-1.715l9.113 5.468c1.294.777 1.294 2.653 0 3.43l-9.113 5.468c-1.333.8-3.029-.16-3.029-1.715"
    }
  )
);
var SvgPlayFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PlayFilled_default = SvgPlayFilled;

export { PlayFilled_default as default };
